import React from 'react'
import { Delete as DeleteIcon, DragIndicatorOutlined as DragIcon, } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { DateService } from 'services/util/DateService';
import { getTemplateStopTypeString } from 'services/enums/TemplateStopType';

const Columns = {
  stopNumber: {
    name: 'stopNumber',
    header: ({ t }) => t('stopNumber'),
    body: ({ stop, classes, provided }) => (
      <div className={classes.firstTableCellContent}>
        <div
          {...provided.dragHandleProps}
          className={classes.dragIcon}
        >
          <DragIcon />
        </div>
        {stop.stopNumber}
      </div>
    )
  },
  name: {
    name: 'name',
    header: ({ t }) => t('name'),
    body: ({ stop }) => `${stop.name || ''}`
  },
  stopCategory: {
    name: 'stopCategory',
    header: ({ t }) => t('stopCategory'),
    body: ({ stop }) => `${stop.stopCategory || ''}`
  },
  customerId: {
    name: 'customerId',
    header: ({ t }) => t('customerId'),
    body: ({ stop }) => stop.customerId
  },
  streetAndNumber: {
    name: 'streetAndNumber',
    header: ({ t }) => t('streetAndNumber'),
    body: ({ stop }) => stop.address?.streetAndNumber || ''
  },
  zipcode: {
    name: 'zipcode',
    header: ({ t }) => t('zipcode'),
    body: ({ stop }) => stop.address?.zipcode || ''
  },
  deliveryWindow: {
    name: 'deliveryWindow',
    header: ({ t }) => t('deliveryWindow'),
    body: ({ stop }) => DateService.displayTime(stop?.deliveryWindow?.from) + ' - ' + DateService.displayTime(stop?.deliveryWindow?.to)
  },
  stopType: {
    name: 'stopType',
    header: ({ t }) => t('stopType'),
    body: ({ stop, t }) => t(getTemplateStopTypeString(stop?.stopType)) || '-'
  },
  delete: {
    name: 'delete',
    header: (_) => '',
    body: ({ stop, classes, deleteStopFromTemplate, t }) => (
      <IconButton
        className={classes.deleteButton}
        onClick={() => deleteStopFromTemplate(stop.id)}
        size="small"
        title={t('deleteStopFromTourTemplate')}
      >
        <DeleteIcon />
      </IconButton>
    )
  },
}

export default Columns;